import { render, staticRenderFns } from "./OperationRecordCreate.vue?vue&type=template&id=a2546652"
import script from "./OperationRecordCreate.vue?vue&type=script&lang=js"
export * from "./OperationRecordCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports